<template>
  <div class="select-users">
    <div class="select-users-table">
      <el-button
        :disabled="!multipleSelection.length"
        type="primary" class="invite" @click="save"
      >Пригласить
      </el-button>
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="email"
          label="Email"
        >
        </el-table-column>
        <el-table-column
          property="name"
          label="Name"
        >
        </el-table-column>
        <el-table-column
          property="phone"
          label="Phone"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'SelectUsers',
  data() {
    return {
      tableData: [],
      multipleSelection: [],
    };
  },
  mounted() {
    const currentID = firebase.auth().currentUser.uid;
    this.tableData = [];
    firebase.firestore()
      .collection('projects')
      .doc(this.$route.params.id)
      .collection('users').get().then((data) => {
      data.forEach((subDoc) => {
        const data = subDoc.data();

        if (data.uid !== currentID && !this.$store.state.project.rules[data.uid]) {
          this.tableData.push({
            id: subDoc.id,
            ...data,
          });
        }
      });

      this.tableData = this.tableData.filter(({isCompany}) => !isCompany)
    });
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;

    },
    save() {
      this.loading = true;
      firebase.firestore().collection('projects').doc(this.$store.state.project.id).get().then((response) => {
        const responseData = response.data();
        if (!responseData) return;
        const promises = [];
        this.multipleSelection.map((user) => {
          promises.push(firebase.firestore()
            .collection('projects')
            .doc(this.$route.params.id)
            .collection('users')
            .where(
              'email',
              '==',
              user.email,
            ).get());
        });

        const userIds = {};
        const users = [];

        Promise.all(promises).then(async (userA) => {
          userA.forEach((user) => {
            user.forEach((x) => {
              const uData = x.data()
              userIds[uData.uid] = uData.role || 'worker';
              users.push({...uData, id: x.id});
            });
          });
          setTimeout(() => {

            firebase.firestore().collection('projects').doc(this.$store.state.project.id).update(
              {
                ...responseData,
                rules: {
                  ...responseData.rules,
                  ...userIds,
                },
              },
            ).then(() => {

              let batch = firebase.firestore().batch();
              users.forEach((doc) => {
                const docRef = firebase.firestore()
                  .collection('projects')
                  .doc(this.$store.state.project.id)
                  .collection('users')
                  .doc();
                batch.set(docRef, {
                  ...doc,
                });
              });
              batch.commit();
              this.$notify({
                offset: 60,
                title: 'Успешно!',
                message: 'Пользователи успешно импортированы',
                type: 'success',
              });

              this.$store.dispatch('setProject', {
                rules: {
                  ...responseData.rules,
                  ...userIds,
                }
              });
              this.$router.back()
            }).catch((e) => {
              console.info(e);
            });
          }, 500);
        })
      });
    },
  },
};
</script>

<style scoped lang="scss">
.select-users {
  max-width: 632px;
  margin: 42px auto;
  width: calc(100% - 40px);
}

.select-users-table {
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  .invite {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/SelectUsers.vue